import { SemanticICONS, SemanticCOLORS } from "semantic-ui-react";
import { ExaminerAvailabilityFilterType } from "../ManageExaminerToRoomStructureFilterBar";

export type AvailabilityDisplay = {
  icon: SemanticICONS;
  color: SemanticCOLORS;
  labelText: string;
  popupHeader: string;
  popupDescription: string;
};

export const getExaminerAvailabilityDisplay = (availability: ExaminerAvailabilityFilterType): AvailabilityDisplay => {
  switch (availability) {
    case ExaminerAvailabilityFilterType.Available:
      return {
        icon: 'circle',
        color: 'green',
        labelText: 'AVAILABLE',
        popupHeader: 'Available',
        popupDescription: 'This examiner is available in its entirety for this exam',
      }
    case ExaminerAvailabilityFilterType.Partially:
      return {
        icon: 'adjust',
        color: 'orange',
        labelText: 'PARTIAL',
        popupHeader: 'Partially available',
        popupDescription: 'This examiner may be allocated for part of this exam time',
      };
    case ExaminerAvailabilityFilterType.Unavailable:
      return {
        icon: 'ban',
        color: 'red',
        labelText: 'UNAVAILABLE',
        popupHeader: 'Unavailable',
        popupDescription: 'This examiner is not available during this exam',
      };
    case ExaminerAvailabilityFilterType.NotProvided:
    default:
      return {
        icon: 'question',
        color: 'blue',
        labelText: 'NOT PROVIDED',
        popupHeader: 'Undecided',
        popupDescription: 'This examiner has not yet determined his availability',
      };
  }
};